import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import OrderSummaryDetailsCard from './OrderSummaryDetailsCard';
import OrderSummaryDescription from 'src/common/components/orderSummaryDescription/OrderSummaryDescription';
import mergeArrays from 'src/common/components/orderSummaryDescription/mergeArrays';
import { OrderTypes } from 'src/constants/orderListConstants';
import { isMobileDevice } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrderSummaryDetails = ({ toggleCard, isFullyInvoiced }) => {
    const orderDescription = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails?.orderDescription
    );

    const orderStatusDescription = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderStatusDescription
    );

    const [replenishment, setReplenishment] = useState([]);
    const [tissue, setTissue] = useState([]);
    const [nonTissue, setNonTissue] = useState([]);
    const [surgeryOrder, setSurgeryOrder] = useState([]);

    useEffectWithErrorLogging(() => {
        let repleneish = (orderDescription || [])?.filter(
            (orderDes) => orderDes.orderType === OrderTypes().REPLENISHMENT || orderDes.orderType === OrderTypes().MAST_REPLENISHMENT
        );

        repleneish = sortOrdersDate(repleneish);

        setReplenishment(repleneish);

        let surgery = (orderDescription || [])?.filter(
            (orderDes) => orderDes.orderType === OrderTypes().SURGERY_ORDER
        );

        surgery = sortOrdersDate(surgery);
        setSurgeryOrder(surgery);

        let billingTissueOrders = (orderDescription || [])?.filter(
            (orderDes) =>
                (orderDes.orderType !== OrderTypes().REPLENISHMENT) &&
                (orderDes.orderType !== OrderTypes().MAST_REPLENISHMENT) &&
                orderDes.salesOrg === 'S030' &&
                orderDes?.price
        );

        billingTissueOrders = sortOrdersDate(billingTissueOrders);

        let surgeryTissueOrders = (orderDescription || [])?.filter(
            (orderDes) =>
                (orderDes.orderType !== OrderTypes().REPLENISHMENT) &&
                (orderDes.orderType !== OrderTypes().MAST_REPLENISHMENT) &&
                orderDes.salesOrg === 'S030' &&
                !orderDes?.price
        );
        surgeryTissueOrders = sortOrdersDate(surgeryTissueOrders);

        setTissue([...billingTissueOrders, ...surgeryTissueOrders]);

        let billingNonTissueOrders = (orderDescription || [])?.filter(
            (orderDes) =>
                (orderDes.orderType !== OrderTypes().REPLENISHMENT) &&
                (orderDes.orderType !== OrderTypes().MAST_REPLENISHMENT) &&
                orderDes.salesOrg !== 'S030' &&
                orderDes?.price
        );

        billingNonTissueOrders = sortOrdersDate(billingNonTissueOrders);

        let surgeryNonTissueOrders = (orderDescription || [])?.filter(
            (orderDes) =>
                (orderDes.orderType !== OrderTypes().REPLENISHMENT) &&
                (orderDes.orderType !== OrderTypes().MAST_REPLENISHMENT) &&
                orderDes.salesOrg !== 'S030' &&
                !orderDes?.price
        );
        surgeryNonTissueOrders = sortOrdersDate(surgeryNonTissueOrders);

        setNonTissue([...billingNonTissueOrders, ...surgeryNonTissueOrders]);
    }, [orderDescription]);

    const sortOrdersDate = (orders) => {
        return orders?.length && orders.length > 0
            ? orders.sort(function (a, b) {
                  if (a.orderDate < b.orderDate) return 1;
                  if (a.orderDate > b.orderDate) return -1;
              })
            : [];
    };

    const OrderSummary = (tissue, nontissue, replenish, surgery) => {
        if (replenish) {
            return <OrderSummaryDescription orderArray={replenish} />;
        } else if (surgery) {
            return <OrderSummaryDescription orderArray={surgery} />;
        } else {
            const orderArray = mergeArrays(tissue, nontissue);
            return <OrderSummaryDescription orderArray={orderArray} />;
        }
    };

    return (
        <>
            <OrderSummaryDetailsCard
             id="orders-ordersummary-details-card"
                title={orderStatusDescription}
                padding={isMobileDevice() ? '20px' : '0.8rem'}
                onClick={() => toggleCard('isFullyInvoiced', !isFullyInvoiced)}
                isExpanded={isFullyInvoiced}
            >
                {isFullyInvoiced ? (
                    <>
                        {OrderSummary(null, null, replenishment, null)}
                        {OrderSummary(tissue, nonTissue, null, null)}
                        {/* {OrderSummary(null, null, null, surgeryOrder)} */}
                    </>
                ) : null}
            </OrderSummaryDetailsCard>
        </>
    );
};

export default OrderSummaryDetails;
